import { Server, Network } from 'tokend-js-sdk'
import config from '@conf'

export function initHorizonServer (networkId) {
  Network.use(new Network(networkId))
  return new Server(config.HORIZON_SERVER, { allowHttp: true })
}



// WEBPACK FOOTER //
// ./src/js/helpers/server.helper.js